import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Data User"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Daftar User")
  ])
], -1)
const _hoisted_3 = { class: "card-header border-0 pt-5" }
const _hoisted_4 = { class: "card-title align-items-start flex-column" }
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Email"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Telepon"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Role"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Posisi"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
], -1)
const _hoisted_9 = { class: "fw-bolder text-muted" }
const _hoisted_10 = { class: "min-w-125px; text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-75px; text-center" }, null, -1)
const _hoisted_13 = { class: "min-w-75px; text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "row mt-5 mb-5" }
const _hoisted_36 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_37 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_38 = ["label", "value"]
const _hoisted_39 = { class: "p-3" }
const _hoisted_40 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_41 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/user/add'))),
            class: "btn btn-primary"
          }, " Tambah User ")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _hoisted_8,
              _createElementVNode("tr", _hoisted_9, [
                _createElementVNode("th", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Cari Nama",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                    onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
                  }, null, 544), [
                    [_vModelText, _ctx.name]
                  ])
                ]),
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("th", _hoisted_13, [
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.idRole,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.idRole) = $event)),
                    placeholder: "Pilih Role",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.listRole,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pilihRole($event)))
                  }, null, 8, ["modelValue", "options"])
                ]),
                _hoisted_14,
                _hoisted_15
              ])
            ]),
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.email), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.phone), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(item.credentialId.role.split("_").join(" ")), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(item.position), 1),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.$router.push('/superadmin/user/detail/' + item._id))
                        }, _hoisted_25, 8, _hoisted_23),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Edit",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.$router.push('/superadmin/user/' + item._id))
                        }, _hoisted_28, 8, _hoisted_26),
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Hapus",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.handleDelete(index, item))
                        }, _hoisted_31, 8, _hoisted_29)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_32, _hoisted_34))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_38))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("ul", _hoisted_41, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}